import { configureStore } from '@reduxjs/toolkit';

import globalReducer from './slices/globalSlice';
import authReducer from './slices/authSlice';
import userReducer from './slices/userSlice';
import visitorReducer from './slices/visitorSlice';
import tabReducer from './slices/tabSlice';
import companySetupReducer from './slices/companySetupSlice';
import siteReducer from './slices/siteSlice';
import allSitesReducer from './slices/allSites';
import currentSiteReducer from './slices/currentSiteSlice';
import allUsers from './slices/allUsers';
import bottomBar from './slices/bottomBarSlice';
import logEntries from './slices/logEntires';
import setReportLayouts from './slices/UIBuilderLayouts';
import reportDataSlice from './slices/reportDataSlice';
import formToggleSlice from './slices/formToggleSlice';
import builderLayoutSlice from './slices/builderLayoutSlice';
import shiftToDoItems from './slices/shiftToDoSlice';
import visitorLogSlice from './slices/visitorLogSlice';
import redZoneSlice from './slices/redZoneSlice';
import incidentReportReducer from './slices/incidentReportSlice';
import deliveryReducer from './slices/deliverySlice';

/* =========================================================
   STORE
   ========================================================= */

const store = configureStore({
  reducer: {
    associatedSites: allSitesReducer,

    site: siteReducer,

    currentSite: currentSiteReducer,

    user: userReducer,

    global: globalReducer,

    auth: authReducer,

    visitor: visitorReducer,

    tab: tabReducer,

    companySetup: companySetupReducer,

    allUsers,

    bottomBar,

    logEntries,

    reportLayouts: setReportLayouts,

    reportData: reportDataSlice,

    formToggle: formToggleSlice,

    builderLayouts: builderLayoutSlice,

    shiftToDo: shiftToDoItems,

    visitorLog: visitorLogSlice,

    redZone: redZoneSlice,

    incidentReport: incidentReportReducer,

    /*
     * Delivery realtime state.
     *
     * delivery:update
     *      ↓
     * RealtimeSocketBridge
     *      ↓
     * deliverySlice
     *      ↓
     * Deliveries screen refetch
     */
    delivery: deliveryReducer,
  },
});

/* =========================================================
   TYPES
   ========================================================= */

export type AppState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

/* =========================================================
   EXPORT
   ========================================================= */

export default store;
